import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Form, Checkbox } from '@deere/ux.uxframe-react'
import Modal from '../../components/Modal';
import DateOfpSection from '../../components/DateOfpSection'
import { updateSurveyAnswers, removeSurveyAnswer } from '../../redux/action/surveyAction';
import { findAnswerIndex, updateAnswerInArray, isCheckBoxAnswer, containsCheckBoxAnswer, getNewCheckValueAnswer, removeQuestion, getTranslation } from '../../utils/utils';
import { OF_KEY, SCBM_SECCIO_CODES, EMPTY_BODY, QUESTION_PROPRIETARY } from '../../utils/surveyLiterals'
import store from '../../redux/store'
import { useTranslation } from "react-i18next";
import "../../assets/css/Sections.css";
import {DebounceInput} from 'react-debounce-input';

export default function Ofp({ survey, ofpCheckBox1, ofpCheckBox2 }) {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const [modalParams, setModalParams] = useState([])
    const [checkSection, setCheckSection] = useState("")
    const surveyResponse = useSelector(state => state.survey.surveyResponse);
    const [answers, setAnswers] = useState([])
    const section = survey.sections.find(e => e.code === SCBM_SECCIO_CODES.OF && e.active);
    const questions = section.questions.filter(qu => qu.active && qu.text !== QUESTION_PROPRIETARY).sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1);
    //const questionsDp = questions.filter(qu => qu.showOrder === 1)[0];
    const propQuestion = section.questions.filter(qu => qu.active && qu.text === QUESTION_PROPRIETARY)[0];
    let tmpAns=useSelector(state => state.survey.surveyAnswers);
    const propComments = propQuestion ? findAnswerIndex(propQuestion.id, tmpAns) >= 0 ? tmpAns[findAnswerIndex(propQuestion.id, tmpAns)].answer : '' : '';
    const [flagFirstQuestion, setFlagFirstQuestion] = useState(true);


    useEffect(() => {
        setAnswers([...store.getState().survey.surveyAnswers])
        if(propComments!==''){ setCheckSection('checked')}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [surveyResponse]);


    if (!survey)
        return EMPTY_BODY;
    
    const handleOnChangeChk = e => {
        let tmpParams = []
        setCheckSection('checked')        
        tmpParams.push(true)
        tmpParams.push(!e.target.checked)
        setModalParams(tmpParams)
    }
    
    const handleModalCancel  = e => {
        let tmpParams = []
        tmpParams.push(false)
        if(!modalParams[1]) setCheckSection('')
        setModalParams(tmpParams)        
    }

    const handleModalSave  = e => {        
        let tmpParams = []
        tmpParams.push(false,true)        
        let tmpChecked = (e.target.id==='save')? 'checked' : ''
        setCheckSection(tmpChecked)
        setModalParams(tmpParams)        
    }

    const updateAnswer = (e, questionId) => {
        dispatch(updateSurveyAnswers({ questionId: questionId, answer: e.target ? e.target.value : e }));
        setAnswers([...store.getState().survey.surveyAnswers])
    }

    const updateCheckAnswer = (e, questionId) => {

        let newCheckValue = getNewCheckValueAnswer(questionId, answers, e);
        if (newCheckValue === null || newCheckValue === '' || newCheckValue === ',') {
            removeQuestion(questionId, answers);
            dispatch(removeSurveyAnswer(questionId));
        } else {
            updateAnswerInArray(questionId, answers, newCheckValue);
            dispatch(updateSurveyAnswers({ questionId: questionId, answer: newCheckValue }));
        }

        setAnswers([...store.getState().survey.surveyAnswers])
    }

    function createRadioSection(data) {
        let indx = findAnswerIndex(data.id, answers);
        return <Form.Group>
            <Form.Label className="uxf-label">{getTranslation(data, 'text')}</Form.Label>
            <div>
                {
                    data.selections.sort((a, b) => (a.value < b.value) ? 1 : -1).map((i) =>
                        i.active ? <Form.Check
                            required={!checkSection}
                            type="radio" value={i.value} inline id={i.id} key={i.id} label={getTranslation(i, 'text')}
                            name={`${getTranslation(section, 'description')}-${data.id}`} onChange={(e) => updateAnswer(e, data.id)} data-testid={i.id}
                            checked={indx >= 0 && answers[indx].answer === i.value} /> : null
                    )
                }
            </div>
        </Form.Group>
    }
    function createTextArea(data) {
        let indx = findAnswerIndex(data.id, answers);
        if (data.idQuestionDepends && data.idQuestionDepends > 0) {
            let questionIndex = findAnswerIndex(data.idQuestionDepends, answers);
            let ans = questionIndex >= 0 ? answers[questionIndex].answer : null;
            let value = '';
            if (questionIndex >= 0 && isCheckBoxAnswer(ans) && containsCheckBoxAnswer(data.idSelectionDependson, ans)) {
                value = data.idSelectionDependson;
            } else if (questionIndex >= 0 && !isCheckBoxAnswer(ans)) {
                value = ans;
            }
            return (value && value.toString() === data.idSelectionDependson.toString()) 
                ? 
                    <div>
                        {
                            //Special solution for the text area Comments
                            ( data.showOrder === 3 ) 
                            ?
                            flagFirstQuestion ? 
                                <Form.Group className="mb-4 pl-4">
                                <Form.Label className="uxf-label">{getTranslation(data, 'text')}</Form.Label>
                                <DebounceInput required={!checkSection} element="textarea" rows="2" aria-describedby="textarea-text" className="form-control" debounceTimeout={300}
                                        onChange={(e) => updateAnswer(e, data.id)}
                                        value={indx >= 0 ? answers[indx].answer : ''} 
                                        name={`${getTranslation(section, 'description')}-${data.id}`}/>
                                <div className="invalid-feedback">
                                    {t('bs_required')}
                                </div>        
                                </Form.Group>   : null
                            : 
                                <Form.Group className="mb-4 pl-4">
                                <Form.Label className="uxf-label">{getTranslation(data, 'text')}</Form.Label>
                                <DebounceInput required={!checkSection} element="textarea" rows="2" aria-describedby="textarea-text" className="form-control" debounceTimeout={300}
                                        onChange={(e) => updateAnswer(e, data.id)}
                                        value={indx >= 0 ? answers[indx].answer : ''} 
                                        name={`${getTranslation(section, 'description')}-${data.id}`}/>
                                <div className="invalid-feedback">
                                    {t('bs_required')}
                                </div>
                                </Form.Group>
                        }
                    </div>
                : null
        } else {
            
            return <Form.Group className="mb-4">
                <Form.Label className="uxf-label" >{getTranslation(data, 'text')}</Form.Label>
                <DebounceInput required={!checkSection} element="textarea" rows="2" aria-describedby="textarea-text" className="form-control" debounceTimeout={300}
                    onChange={(e) => updateAnswer(e, data.id)}
                    value={indx >= 0 ? answers[indx].answer : ''} 
                    name={`${getTranslation(section, 'description')}-${data.id}`}/>                
                <div className="invalid-feedback">
                    {t('bs_required')}
                </div>    
            </Form.Group>
        }
    }

    function createCheckSection(data) {
        let indx = findAnswerIndex(data.id, answers);
        if (data.idQuestionDepends && data.idQuestionDepends > 0) {
            let questionIndex = findAnswerIndex(data.idQuestionDepends, answers);
            let ans = questionIndex >= 0 ? answers[questionIndex].answer : null;
            let value = '';
            if (questionIndex >= 0 && isCheckBoxAnswer(ans) && containsCheckBoxAnswer(data.idSelectionDependson, ans)) {
                value = data.idSelectionDependson;
            } else if (questionIndex >= 0 && !isCheckBoxAnswer(ans)) {
                value = ans;
            }

            return (value && value === data.idSelectionDependson.toString()) ? <Form.Group className="mb-4 pl-4">
                <Form.Label className="uxf-label">{getTranslation(data, 'text')}</Form.Label>
                <div>
                    {
                        data.selections.sort((a, b) => (a.value > b.value) ? 1 : -1).map((i) =>
                            i.active ? <Form.Check name={`${getTranslation(section, 'description')}-${data.id}`} inline id={i.id} value={i.value} key={i.id} label={getTranslation(i, 'text')} size='sm'
                                onChange={(e) => updateCheckAnswer(e, data.id)}
                                data-testid={i.id} checked={indx >= 0 ? containsCheckBoxAnswer(i.value, answers[indx].answer) : false} 
                                checkedproprietary={checkSection}/> : null
                        )
                    }
                </div>
            </Form.Group> : null
        } else {
            return <Form.Group className="mb-4">
                <Form.Label className="uxf-label">{getTranslation(data, 'text')}</Form.Label>
                <div>
                    {
                        data.selections.map((i) =>
                            i.active ? <Form.Check name={`${getTranslation(section, 'description')}-${data.id}`} inline id={i.id} value={i.value} key={i.id} label={getTranslation(i, 'text')} size='sm'
                                onChange={(e) => updateCheckAnswer(e, data.id)} data-testid={i.id}
                                checked={indx >= 0 ? containsCheckBoxAnswer(i.value, answers[indx].answer) : false} 
                                checkedproprietary={checkSection}/> : null
                        )
                    }
                </div>
            </Form.Group>
        }
    }

    function createDependentCol(question) {

        let questionIndex = findAnswerIndex(question.idQuestionDepends, answers);
        let ans = questionIndex >= 0 ? answers[questionIndex].answer : null;
        let value = '';
        if (questionIndex >= 0 && isCheckBoxAnswer(ans) && containsCheckBoxAnswer(question.idSelectionDependson, ans)) {
            value = question.idSelectionDependson;
        } else if (questionIndex >= 0 && !isCheckBoxAnswer(ans)) {
            value = ans;
        }

        if(value && value.toString() === question.idSelectionDependson.toString())  {
            return (question.type === 'OPTION') ?
                 <td className='p-1' key={question.id}>
                    {createCheckSection(question)}
                </td>
            : null;
        } else {
            return null;
        }
    }

    function createDateSection(data) {
        let questionIndex = findAnswerIndex(data.idQuestionDepends, answers);
        let ans = questionIndex >= 0 ? answers[questionIndex].answer : null;
        let value = '';
        if (questionIndex >= 0 && isCheckBoxAnswer(ans) && containsCheckBoxAnswer(data.idSelectionDependson, ans)) {
            value = data.idSelectionDependson;
        } else if (questionIndex >= 0 && !isCheckBoxAnswer(ans)) {
            value = ans;
        }
        return (value && value === data.idSelectionDependson.toString()) ? <DateOfpSection ofpSection={section} dateQuestion={data} updateCheckAnswer={updateCheckAnswer} answers={answers} updateAnswer={updateAnswer} checkedProprietary={checkSection} />: null
    }  

    return (<>
        <Card>
            <Card.Body id={section ? section.description : ''}>
                <Card.Title className='pb-3 font-weight-bold'>
                    {getTranslation(section,'description')}
                    {
                        propQuestion &&
                        <Checkbox checked={checkSection} className='float-right m-0 ss' label={getTranslation(propQuestion,'text')} id='chBoxPropertyInfoOfp' onChange={handleOnChangeChk} />
                    }
                </Card.Title>
                <>
                    {
                        <>
                            {
                                questions.map((q, index) =>
                                    <div key={index}>
                                        <Form.Row className="d-block mb-4">
                                            {q.type === 'RADIO' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createRadioSection(q) : <></>}
                                            {q.type === 'OPEN' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createTextArea(q) : <></>}
                                            {q.type === 'CHECK' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createCheckSection(q) : <></>}
                                            {q.type === 'OPTION' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createDependentCol(q) : <></>}

                                        </Form.Row>
                                        {q.type === 'DATE_SECT' ? createDateSection(q) : <></>}
                                    </div>
                                )
                            }
                        </>
                    }
                </>
            </Card.Body>
        </Card>
        { modalParams.length > 0 ? <Modal warning={modalParams[1]} section={OF_KEY} show={modalParams[0]} handleClose={handleModalCancel} handleSave={handleModalSave} propQuestion={propQuestion.id} /> :null}
    </>)
}
